/** Origin only. Callers append `/api/...` or `/health`. */
export function normalizeApiBaseUrl(raw: string): string {
  return String(raw || '')
    .trim()
    .replace(/\/+$/, '')
    .replace(/\/api$/i, '');
}
